<template>
  <div>
    <div
      v-if="isLoading"
      id="loader-wrapper"
    >
      <div id="loader" />
    </div>
    <transition name="fade">
      <div v-if="success">
        <div class="hero-subheader">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div
                  class="align-container"
                  data-mh=""
                >
                  <div class="align-inner">
                    <h1 class="hero-subheader__title text-center">
                      Muito Obrigado!
                    </h1>
                    <p class="hero-subheader__desc text-center">
                      Sua sugestão foi registrada com
                      sucesso.
                    </p>
                    <p class="hero-subheader__desc text-center">
                      Para registrar uma nova entrada, <a href="#" @click.prevent="window.location.reload();">clique aqui</a> ou recarregue essa página.
                    </p>
                    <p class="text-center">
                      <small>Para outros dados do levantamento, <a
                        href="https://www.atlas.jor.br/equipe"
                      >clique
                        aqui</a></small>
                    </p>
                  </div><!-- /.align-inner -->
                </div><!-- /.align-container -->
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div><!-- /.container -->
        </div>
      </div>
    </transition>
    <div v-if="!success">
      <div class="row">
        <div class="col-md-12">
          <media-suggestion-form
            v-model="mediaForm"
            :media-form-data="mediaForm"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <media-form
            v-model="media"
            :media-data="media"
            @startAjax="setLoadingState(true)"
            @endAjax="setLoadingState(false)"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <button
            type="button"
            class="btn btn-atlas"
            @click="sendForm"
          >
            Enviar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Noty from 'noty';
import MediaSuggestionForm from './MediaSuggestionForm';
import MediaForm from './MediaForm';
import httpClient from '../infra/httpClient';
import Api from '../../admin/js/services/Api';

const endpoint = 'suggestion';

export default {
  components: { MediaForm, MediaSuggestionForm },
  data: () => ({
    mediaForm: null,
    media: null,
    api: new Api('/api/v1/', httpClient),
    isLoading: true,
    success: false,
  }),
  methods: {
    setLoadingState(state) {
      this.isLoading = state;
    },
    async sendForm() {
      if (!this.mediaForm || !this.media) {
        this.showNoty('O formulário deve ter seus campos preenhidos.');
        return;
      }

      this.setLoadingState(true);
      const form = {
        media_form: this.mediaForm,
        media: this.media,
      };
      let response = null;
      if (this.media.media.value) {
        response = await this.api.update(this.media.media.value, form, endpoint);
      } else {
        response = await this.api.store(form, endpoint);
      }

      this.setLoadingState(false);
      if (response.status === 200) {
        this.success = true;
      } else {
        for (const error in response.data.errors) {
          response.data.errors[error].forEach((m) => {
            this.showNoty(m);
          });
        }
      }
    },
    showNoty(message) {
      new Noty({
        type: 'error',
        layout: 'top',
        theme: 'metroui',
        text: message,
        timeout: 3000,
      }).show();
    },
  },
};
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .hero-subheader {
        color: #008596;
        background-image: url(/images/cover.svg?749fbe9…) !important;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: left;
        background-attachment: fixed;
    }

    @media (min-width: 768px) {
        .hero-subheader {
            padding: 4.1rem 0px 4.2rem;
        }
    }

</style>
